import React from 'react'

import { Spin} from 'antd';
export default function LoadingPage(/* props */) {
    //  indicator={<Icon type="loading-3-quarters" style={{ fontSize: 32 }} spin />}
    return (
        <div className="page-center text-center">
          <Spin spinning={true} size="large"></Spin>
        </div>
    )
}